export default "/kiban/_next/static/images/platina-d9127fc4986483b62704025e3e412406.gif";